<section class="approve-page">
  <div class="approve-card">
    <h1>{{ 'app.components.parentLinkApproval.title' | translate }}</h1>
    <p [class.success]="status() === 'success'" [class.error]="status() === 'error'">
      {{ messageKey() | translate }}
    </p>

    <div class="spinner" *ngIf="status() === 'loading'"></div>

  </div>
</section>

